import React from "react";
import GlobalContext from "../GlobalContext";
import ListingEntry from "../ListingEntry/ListingEntry";

import './ResultsDisplay.css';
import Loading from "../Loading/Loading";

function ResultsDisplay(){
  const global = React.useContext(GlobalContext);

  let result;

  if(
    Object.keys(global.state.filters).length === 0 || 
    (
      (!global.state.query || global.state.filters.query === "") && (!global.state.filters.categories || global.state.filters.categories.size === 0))
    ){
    result = <div className="empty">Please enter search criteria to continue</div>;
  } else if(global.state.loading){
    result = <Loading />;
  } else if(global.state.records.length === 0){
    result = <div className="no-results">No results found.</div>;
  } else {
    result = global.state.records.map(record => {
      return (
        <ListingEntry 
          key={ `tile-${record.id}` }
          slug={ record.slug }
          title={ record.title }
          logo={ record.logo }
          logo_ext={ record.logo_ext }
          excerpt={ record.excerpt }
          keywords={ record.keywords }
        />
      );
    });
  }

  return (
    <div className="results-display">
      <ul> { result }</ul>
    </div>
  );
}

export default ResultsDisplay;